<template>
  <div class="wiens-law-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>λ_max · T = b | 观测恒星温度的方法$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Radiation Spectrum Graph -->
          <g transform="translate(50, 200)">
             <!-- Axis -->
             <line x1="0" y1="0" x2="320" y2="0" stroke="#888" />
             <line x1="0" y1="0" x2="0" y2="-180" stroke="#888" />
             <text x="330" y="5" fill="#888" font-size="8">波长 λ (nm)</text>
             <text x="-40" y="-170" fill="#888" font-size="8">强度 I</text>

             <!-- The Curve (Plank Law approximation) -->
             <path :d="plankCurve" fill="rgba(255, 215, 0, 0.1)" stroke="#ffd700" stroke-width="2" />
             
             <!-- Peak indicator -->
             <line :x1="peakX" y1="0" :x2="peakX" y2="-170" stroke="#ff4757" stroke-dasharray="4,2" />
             <text :x="peakX - 20" y="-180" fill="#ff4757" font-size="10">λ_max</text>
             
             <!-- Visible spectrum bar -->
             <rect x="100" y="5" width="100" height="5" fill="url(#viz-grad)" />
             <defs>
                <linearGradient id="viz-grad">
                   <stop offset="0%" stop-color="#8b00ff" />
                   <stop offset="20%" stop-color="#0000ff" />
                   <stop offset="40%" stop-color="#00ff00" />
                   <stop offset="60%" stop-color="#ffff00" />
                   <stop offset="80%" stop-color="#ff7f00" />
                   <stop offset="100%" stop-color="#ff0000" />
                </linearGradient>
             </defs>
          </g>

          <!-- The glowing object -->
          <circle cx="340" cy="50" r="30" :fill="peakColor" opacity="0.8" />
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>预测温度 T: {{ (3000 / (peakX/50)).toFixed(0) }} K</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center">
             <label>调节热力学温度 T</label>
             <el-slider v-model="tempSlider" :min="10" :max="100" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
           <p><strong>物理详解：</strong>维恩位移定律描述了黑体辐射产生的电磁波波长与温度的关系：**最大辐射功率对应的波长 λ_max** 与绝对温度成反比。简单来说，物体越热，它发出的光的主色调就越偏向能量更高、波长更短的蓝紫色方向（蓝移）；反之则偏向红外方向。这就是为什么我们可以通过分析遥远恒星的光谱色调，来精确测量几万光年外天体的表面温度。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WiensLawViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      tempSlider: 30
    }
  },
  computed: {
    peakX() {
       return 500 / this.tempSlider * 10;
    },
    peakColor() {
       let x = this.peakX;
       if (x < 100) return "#8b00ff"; // UV/Violet
       if (x < 130) return "#0000ff"; // Blue
       if (x < 160) return "#00ff00"; // Green
       if (x < 200) return "#ffff00"; // Yellow
       return "#ff4757"; // Red/Infrared
    },
    plankCurve() {
       let d = "M 0 0 ";
       let T = this.tempSlider;
       for (let x = 1; x <= 320; x += 5) {
          // Simpliled Plank-like shape: x^3 / (e^(x/T) - 1)
          let val = (Math.pow(x, 1.5) / (Math.exp(x / T) - 0.5)) * 0.1;
          d += `L ${x} ${-Math.min(val, 170)} `;
       }
       return d;
    }
  }
}
</script>

<style scoped lang="scss">
.wiens-law-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(255, 159, 67, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
